/*
  ADA / WCAG 1.4.3 (2026-10-07): Replo landing pages render some prices and
  captions in Replo's #8c8c8c grey, which is 3.19:1 on the page background
  (4.5:1 is required). Replo regenerates its per-element classes on every
  republish and sets the colour in those rules, so there is no stable CSS hook
  for a theme override. This lifts that one grey to a passing shade at runtime
  instead: darker on light backgrounds, lighter on dark ones. No other colour
  is touched, so anything a designer chose on purpose stays as it is.
*/
(function () {
  var REPLO_GREY = 'rgb(140, 140, 140)';
  var ON_LIGHT = '#6f6f6f'; /* 4.8:1 on #faf9f6, 5.0:1 on white */
  var ON_DARK = '#b3b3b3';  /* 8.6:1 on #1d1d1d */
  var pending = false;

  function channel(v) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  }

  function luminance(r, g, b) {
    return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
  }

  /* Luminance of the first opaque background behind the element (1 = white). */
  function backgroundLuminance(el) {
    for (var p = el; p; p = p.parentElement) {
      var m = getComputedStyle(p).backgroundColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
      if (m && (m[4] === undefined || parseFloat(m[4]) > 0.5)) return luminance(+m[1], +m[2], +m[3]);
    }
    return 1;
  }

  function fix() {
    pending = false;
    var els = document.querySelectorAll('.alchemy-rte, .alchemy-rte p, .alchemy-rte span, .alchemy-rte s, .alchemy-rte a');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.hasAttribute('data-ada-contrast') || getComputedStyle(el).color !== REPLO_GREY) continue;
      el.setAttribute('data-ada-contrast', '');
      el.style.setProperty('color', backgroundLuminance(el) > 0.4 ? ON_LIGHT : ON_DARK, 'important');
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(fix, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
  window.addEventListener('load', schedule);
  /* Replo draws parts of the page (product galleries, carousels) after load. */
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
